import React, { useState, useEffect } from "react";
import AirQualityDisplay from "./components/AirQualityDisplay";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./index.css";

const DATA_URL =
  "https://wroclaw-smierdzi.storage.googleapis.com/apidata/air.json"; 

function App() {
  const [currentAirQuality, setCurrentAirQuality] = useState(null);
  const [calendarData, setCalendarData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(DATA_URL);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setCurrentAirQuality(data.current);
        setCalendarData(data.historical || {});
      } catch (error) {
        console.error("Error fetching data from bucket:", error);
      }
    };

    fetchData();
  }, []);

  const tileClassName = ({ date, view }) => {
    if (view === "month") {
      const dateString = date.toISOString().slice(0, 10);
      const aqi = calendarData[dateString];
      if (aqi >= 4) {
        return "stinky-day";
      }
    }
    return null;
  };

  return (
    <div className="container">

      {currentAirQuality && (
        <AirQualityDisplay data={currentAirQuality} />
      )}

      {/* <div className="calendar-container">
        <h2>Historical Data (AQI)</h2>
        <Calendar
          tileClassName={tileClassName}
          value={new Date()}
          showNavigation={false}
        />
      </div> */}
    </div>
  );
}

export default App;